import { comparatorByCategoryThenByName } from 'utils/sort';

export const getData = (items, extractBeaconData) => items
    .map(item => extractBeaconData(item))
    .sort((item1, item2) => {
        const itemA = item1.allData.item;
        const itemB = item2.allData.item;
        return comparatorByCategoryThenByName(itemA.category, itemA.name, itemB.category, itemB.name);
    });